import { auditActions, auditCategories, type AuditFilter } from '@pm-tool/shared';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { useCallback } from 'react';
import { z } from 'zod';
import { AuditLog } from '@/features/admin/audit/audit-log';
import { requirePermission } from '@/features/admin/guard';
import { featuresQuery } from '@/features/feature-flags/use-feature';

/** Filters live in the URL, e.g. „Verlauf“ of a user links here with `userId`. */
const searchSchema = z.object({
  from: z.iso.date().optional().catch(undefined),
  to: z.iso.date().optional().catch(undefined),
  category: z.enum(auditCategories).optional().catch(undefined),
  action: z.enum(auditActions).optional().catch(undefined),
  userId: z.uuid().optional().catch(undefined),
  highlighted: z.boolean().optional().catch(undefined),
  q: z.string().optional().catch(undefined),
});

/** ADM-05; behind the feature flag `audit_log`. */
export const Route = createFileRoute('/_app/admin/audit')({
  validateSearch: searchSchema,
  beforeLoad: async ({ context }) => {
    requirePermission(context.me, 'admin.audit');
    const { flags } = await context.queryClient.query(featuresQuery);
    if (!flags.audit_log) throw notFound();
  },
  component: AuditPage,
});

function AuditPage() {
  const filters = Route.useSearch();
  const navigate = Route.useNavigate();
  const onFiltersChange = useCallback(
    (next: AuditFilter) => {
      void navigate({ search: next, replace: true });
    },
    [navigate],
  );
  return <AuditLog filters={filters} onFiltersChange={onFiltersChange} />;
}
